







import Vue from "vue"
import { BannerListView } from "~/clApi/viewModel/ad"
import PPcCarouselBanner from "~/components/custom/banner/PPcCarouselBanner.vue"

interface DataType {
  bannerList: BannerListView | null
}

export default Vue.extend({
  components: {
    PPcCarouselBanner,
  },
  data(): DataType {
    return {
      bannerList: null,
    }
  },
  beforeMount() {
    this.fetchBannerList()
  },
  methods: {
    async fetchBannerList() {
      this.bannerList = await this.$clApi.main.general.ad.read.getBannerList()
    },
  },
})
